import { BaseEntity } from "yt-ng-framework";

export class OsobaEmailView extends BaseEntity{
    constructor(){
        super();
    }

    Email:string = null;
    Svojina:string = null;
    Glavni:boolean=null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Email=input.Email;
        this.Glavni=input.Glavni;
        this.Svojina=input.Svojina;
        return this;
    }

    Serialize(input:OsobaEmailView){
        return input;
    }
}